<template>
    <el-card class="box-card main-card">
        <el-form :model='notifyForm' :rules="rules" ref="notifyForm">
            <el-form-item prop="title" class="pxy-form-content" label="">
                <span class="pxy-label el-form-item__label">标题：</span>
                <el-input class="title-input" v-model="notifyForm.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item prop="content" class="pxy-form-content">
                <span class="pxy-label el-form-item__label">内容：</span>
                 <!-- :height="realHeight" -->
                <tinymce-editor id="editor" ref="editor" v-model="notifyForm.content" @handleImgUpload="imgUpload"/>
                <!-- <el-input v-model="notifyForm.content" placeholder="请输入标题"></el-input> -->
            </el-form-item>
            <el-form-item prop="" label="" class="pxy-form-content">
                <span class="pxy-label el-form-item__label">发送时间：</span>
                <el-radio-group v-model="notifyForm.radio" @change="sendDataChange">
                    <el-radio :label="1">
                        <template>
                            <span>预定发送开始时间</span>&nbsp;&nbsp;<br/>
                            <el-date-picker v-model="notifyForm.planSendDate" type="datetime" :disabled="notifyForm.radio===2"
                                placeholder="选择日期时间" size="small">
                            </el-date-picker>
                        </template>
                    </el-radio>
                    <br/>
                    <el-radio :label="2">立即发送</el-radio>
                </el-radio-group>
            </el-form-item>
          <el-form-item prop="" label="" class="pxy-form-content">
            <span class="pxy-label el-form-item__label">轮播结束：</span>
            <el-date-picker v-model="notifyForm.noticeEndDate" type="datetime"
                            placeholder="选择日期时间" size="small">
            </el-date-picker>
          </el-form-item>
            <el-form-item prop=" " lebel=" " class="pxy-form-content" >
                <el-button type="primary" class="pxy-primary" plain size="small" @click="saveHandler">保存</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>
<script>
    import {Message} from "element-ui";
    import { formatDateTime } from "@/utils/util"
    import TinymceEditor from '@/components/editor/tinymce-editor'
    export default {
        components: {
            TinymceEditor
        },
        data() {
            return {
                notifyId: '', //修改时使用
                notifyForm: {
                    title: '',
                    content: '',
                    radio: 1,
                    planSendDate: '',
                    noticeEndDate: ''
                },
                rules: {
                    title: [{required: true, message:'请输入标题！', trigger: 'blur'}],
                    content: [{required: true, message:'请输入内容！', trigger: 'blur'}],
                },
            }
        },
        created() {
            // console.log(this.$route);
            if(this.$route.query.handle === 'update') {// 修改
                const info = JSON.parse(this.$route.query.info);
                console.log(info)
                this.notifyId = info.id;
                this.notifyForm = Object.assign({},{
                    title: info.title,
                    content: info.content,
                    radio: 1, // 可以修改的都是预定时间发送
                    planSendDate: this.formatDateTime(info.planSendDate),
                  noticeEndDate: this.formatDateTime(info.noticeEndDate)
                })
            } else { // 新增
                this.setPlanSendDate();
            }
        },
        methods: {
            setPlanSendDate () {
                const nowD = new Date();
                this.notifyForm.planSendDate = this.formatDateTime(nowD.getTime()+3600*1000)
              this.notifyForm.noticeEndDate = this.formatDateTime(nowD.getTime()+24*3600*1000)
            },
            sendDataChange(value) {
                if(value === 2) this.notifyForm.planSendDate = '';
            },
            saveHandler() {
                this.$refs.notifyForm.validate(valid => {
                    if(valid) {
                        var params = {
                            title: this.notifyForm.title,
                            content: this.notifyForm.content,
                            planSendDate: this.notifyForm.radio === 1? new Date(this.notifyForm.planSendDate).getTime():new Date().getTime(),
                          noticeEndDate: new Date(this.notifyForm.noticeEndDate).getTime()
                        };
                        if(this.notifyId !== '') params.id = this.notifyId;
                        let url = this.notifyId === ''?'/mncNotice/add': '/mncNotice/update';
                        this.postRequestJson(url, params).then(resp => {
                        if (resp.status == 200) {
                            if (resp.data.code == 1000) {
                                this.notifyId === ''? Message.success('添加成功！'): Message.success('修改成功！');
                                this.$router.go(-1);
                            } else {
                            Message.error(resp.data.message);
                            }
                        } else {
                            console.error("error")
                        }
                        })
                    }
                })
            },
             async imgUpload(blobInfo, success, failure) {
                const formData = new FormData();
                formData.append('file', blobInfo.blob());
                try {
                this.postMultipartRequest('/util/upload/picFile', formData).then(resp => {
                    if (resp && resp.status == 200) {
                    var url = resp.data.result.url;
                    success(url);

                    }
                })

                } catch (e) {
                console.log(e);
                failure('上传失败:' + e);
                }
            },
        }
    }
</script>
<style>
@media screen and (max-width: 768px) {
    .el-form-item.pxy-form-content .el-form-item__content {
        margin-left: 0!important;
    }
    .pxy-label.el-form-item__label {
        display: block;
        width: 100%;
        text-align: left;
    }
}
@media screen and (min-width: 769px) {
    .el-form-item.pxy-form-content .el-form-item__content {
        margin-left: 100!important;
    }
    .el-form-item.pxy-form-content .el-form-item__content .title-input {
        width: 500px;
    }
    .el-form-item.pxy-form-content .el-form-item__error {
       left: 100px!important;
    }
    .pxy-label.el-form-item__label {
        width: 100px;
        text-align: right;
        vertical-align: middle;
        float: left;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
}
</style>
